exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container {\n    width: 100%;\n    height: auto;\n}\n.panel2, .panel21 {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    /*margin-bottom: 5%;*/\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n* {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aee5953a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMEditBankAccount.vue
// module id = 1163
// module chunks = 2